<template>
  <b-container>
    <h1>Department</h1>

    <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>
    
    <b-row>
      <b-col md="6">
        <b-button to="/department/add" variant="primary">Add</b-button>
        
        <b-table-lite class="mt-2" :fields="fields" :items="departments">
          <template v-slot:cell(actions)="data">
            <div class="float-right">
            <b-button size="sm" variant="outline-secondary" class="mr-2" :to="`/department/${data.item.id}`">
              <b-icon-card-text></b-icon-card-text>
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="showDeleteDlg(data.item)"><b-icon-trash></b-icon-trash></b-button>
            </div>
          </template>
        </b-table-lite>
      </b-col>
    </b-row>

    <b-modal 
      title="Confirm Delete" 
      v-model="deleteDialog"
      ok-variant="danger"
      cancel-variant="outline-secondary"
      ok-title="Delete"
      @ok="deleteDepartment"
    >
      <p>Delete {{ deleteItem.name }}?</p>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      fields: ['name', { key: 'actions', label: '' }],
      departments: [],
      deleteDialog: false,
      deleteItem: {},
      error: ''
    }
  },
  methods: {
    showDeleteDlg(item) {
      this.error = '';
      this.deleteItem = item;
      this.deleteDialog = true;
    },
    deleteDepartment() {
      axios.delete(`/api/departments/${this.deleteItem.id}`)
      .then(() => {
        const index = this.departments.indexOf(this.deleteItem);
        if (index > -1) {
          this.departments.splice(index, 1);
        }
      })
      .catch(() => {
        this.error = 'Failed to delete department.'
      })
    }
  },
  created() {
    axios.get('/api/departments')
      .then( response => {
        this.departments = response.data
      }).catch(error => {
        console.log(error);
      })
  }
}
</script>